// extracted by mini-css-extract-plugin
export default {"selectMode":"usermanagement_selectMode__3AWAO","canvas_img":"usermanagement_canvas_img__UcY4+"};